import { DataRoomNode } from 'router/subrouters/DataRoom/models/DataRoomNode';
import { ObjectValues } from 'types';
import { LeadState } from './Lead';

export type WorkflowConfigurationProgression = {
  showInterestPopup: boolean;
  completionAction: StepCompletionAction;
  progressionQuestion?: ProgressionQuestion;
};

export type WorkflowConfiguration = {
  step?: LeadState;

  // General rules
  immediatelyAcceptVerifiedBuyers?: boolean;

  // Specific rules
  automaticallySendNDA: boolean;
  automaticallySendNDAEnabled: boolean;

  maxCapacity: number;
  maxCapacityEnabled: boolean;

  // Files
  dataRoomDocumentsAvailability: { dataRoomNodeId: string; checked: boolean }[];
} & WorkflowConfigurationProgression;

export type WorkflowTemplateValues = {
  specificRules: Partial<WorkflowConfiguration>;
  generalRules: Partial<WorkflowConfiguration>;
  maxCapacity?: number;
} & WorkflowConfigurationProgression;

export type StepWorkflowConfiguration = {
  workflowConfigurationStep: WorkflowConfiguration;
  dataRoomNodes: DataRoomNode[];
  checkedFilesIds: string[];
};

export type WorkflowConfigurationSteps = {
  _id: string;
  workflowConfigurationSteps: WorkflowConfiguration[];
};

export type WorkflowConfigurationStepsCapacity = Record<LeadState, number>;

export type ProgressionAnswer = {
  _id: string;
  text: string;
  advancesLead: boolean;
};

export type ProgressionQuestion = {
  question: string;
  answers: ProgressionAnswer[];
};

export const STEP_COMPLETION_ACTION = {
  KEEP: 'keep',
  ASK_PROGRESSION_QUESTION: 'ask_progression_question',
  AUTO_ADVANCE: 'auto_advance',
} as const;

export type StepCompletionAction = ObjectValues<typeof STEP_COMPLETION_ACTION>;
